<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button class="btn-primary" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button class="btn-primary" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <div class="w-1/2">
      <mat-label>選項</mat-label>
        <app-jkcombobox #utymc020 label="customId" [(value)]="filterOpt.mc020" [items]="customIdList" [showClearButton]="true">
        </app-jkcombobox>
      <app-jkedit [visible]="true" [label]="'電腦名稱(部份)'" [required]="false" [(value)]="filterOpt.mc011" [width]="'60'">
      </app-jkedit>
      <app-jkedit [visible]="true" [label]="'外部IP'" [required]="false" [(value)]="filterOpt.mc003" [width]="'60'">
      </app-jkedit>
      <app-jkedit [visible]="true" [label]="'內部IP'" [required]="false" [(value)]="filterOpt.mc009" [width]="'60'">
      </app-jkedit>
      <app-jkedit [visible]="true" [label]="'VM主機'" [required]="false" [(value)]="filterOpt.mc013" [width]="'60'">
      </app-jkedit>
      <app-jkcombobox #orderby label="排序方式" [value]="filterOpt.orderBy" [items]="orderList">
        </app-jkcombobox>
    </div>

</mat-tab>
  <mat-tab #myTabDetail label="詳細資料">
    <app-jkgridwin #jkgridwin
      (afterGridReady)="afterGridReady($event)">
    </app-jkgridwin>
    <label>{{logMessage}}</label>
  </mat-tab>
</mat-tab-group>

